"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOwnersIdsAsSelectInputOptions = exports.getFetchOwnersRequestStatus = exports.getOwners = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-content-modals/data/selectors");

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("settings-content-modals/data/Owners/actions");

var _getRequestStatus = _interopRequireDefault(require("settings-content-modals/data/RequestStatuses/getRequestStatus"));

var getOwners = (0, _reselect.createSelector)(_selectors.getModalSelector, function (state) {
  return state.owners;
});
exports.getOwners = getOwners;
var getFetchOwnersRequestStatus = (0, _getRequestStatus.default)(_actions.OwnersActionTypes.FETCH_OWNERS);
exports.getFetchOwnersRequestStatus = getFetchOwnersRequestStatus;
var getOwnersIdsAsSelectInputOptions = (0, _reselect.createSelector)([getOwners], function (owners) {
  return owners.reduce(function (acc, owner) {
    var text = owner.firstName || owner.lastName ? _I18n.default.text('settingsContentModals.propertyDefaultsModals.firstNameLastName', {
      firstName: owner.firstName,
      lastName: owner.lastName
    }) : owner.email;
    acc.push({
      text: text,
      value: owner.get('ownerId').toString()
    });
    return acc;
  }, []);
});
exports.getOwnersIdsAsSelectInputOptions = getOwnersIdsAsSelectInputOptions;